import { ReactNode } from "react";
import { useSellarUser } from "../../hooks";

export function AdminOnly(props: { children: ReactNode }) {
  const { user } = useSellarUser();

  if (user?.type === "admin") return <>{props.children}</>;
  return null;
}
